

let token = localStorage.getItem('ebphtb_tarakan_token');
let userTemp = localStorage.getItem('ebphtb_tarakan_user');
let user = null;
try {
    user = userTemp != null ? JSON.parse(userTemp) : null;
} catch (error) {
    token = null;
    user = null;
}
const initialState = token
    ? { status: { loggedIn: true }, token, user }
    : { status: { loggedIn: false }, token: null, user: null };

export const auth = {
    namespaced: true,
    state: initialState,
    getters: {
        token: state => state.token
    },
    actions: {
        async login({ commit }, data) {
            localStorage.setItem('ebphtb_tarakan_token', data.auth_token);
            localStorage.setItem('ebphtb_tarakan_user', JSON.stringify(data.user));
            commit('loginSuccess', data);
        },
        set_user({ commit }, user) {
            localStorage.setItem('ebphtb_tarakan_user', JSON.stringify(user));
            commit('setUserSuccess', user);
        },
        logout({ commit }) {
            localStorage.removeItem('ebphtb_tarakan_token');
            localStorage.removeItem('ebphtb_tarakan_user');
            commit('logout');
        }
    },
    mutations: {
        loginSuccess(state, data) {
            state.status.loggedIn = true;
            state.token = data.auth_token;
            state.user = data.user;
        },
        setUserSuccess(state, user) {
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.token = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.token = null;
        }
    }
};